import { jsx as _jsx } from "react/jsx-runtime";
import { Location } from "@air/next-icons";
import { memo } from "react";
import { InfoPanelDetailsSection } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection";
import { InfoPanelDetailValue } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailValue";
import { isObjectArrayMetadataType } from "~/utils/iptcDataTypes";
export const InfoPanelLocation = /*#__PURE__*/ memo((param)=>{
    let { clipMetadata } = param;
    var _clipMetadata_find, _clipMetadata_find1, _clipMetadata_find2;
    let city = (_clipMetadata_find = clipMetadata.find((metadata)=>metadata.fieldName === "City")) === null || _clipMetadata_find === void 0 ? void 0 : _clipMetadata_find.data;
    let state = (_clipMetadata_find1 = clipMetadata.find((metadata)=>metadata.fieldName === "ProvinceState")) === null || _clipMetadata_find1 === void 0 ? void 0 : _clipMetadata_find1.data;
    let country = (_clipMetadata_find2 = clipMetadata.find((metadata)=>metadata.fieldName === "CountryName")) === null || _clipMetadata_find2 === void 0 ? void 0 : _clipMetadata_find2.data;
    if (!city && !state && !country) {
        const locationShown = clipMetadata.find((metadata)=>metadata.fieldName === "LocationShown");
        if (locationShown && isObjectArrayMetadataType(locationShown) && locationShown.data.length > 0) {
            const location = locationShown.data[0];
            city = location["City"];
            state = location["ProvinceState"];
            country = location["CountryName"];
            if (!city && !state && !country) {
                return null;
            }
        } else {
            return null;
        }
    }
    const locationText = [
        city,
        state,
        country
    ].filter(Boolean).join(", ");
    return /*#__PURE__*/ _jsx(InfoPanelDetailsSection, {
        Icon: Location,
        title: "Location",
        children: /*#__PURE__*/ _jsx(InfoPanelDetailValue, {
            value: locationText
        })
    });
});
InfoPanelLocation.displayName = "InfoPanelLocation";
